<template>
	<div class="c-station-detail">
		<button class="button-back" v-on:click.prevent="back">
			<svg class="icon icon_arrow"><use xlink:href="#icon_arrow"></use></svg>
			Terug naar alle stations
		</button>
		<div class="c-controller">
			<h2>{{ title }}</h2>
			<StationSlide v-if="!loading" v-for="slide in slides" :key="slide.uuid" :slide="slide" :currentSlide="currentSlide" @next="nextSlide" @activate="setSlide" />
		</div>
	</div>
</template>

<script>
import StationSlide from './StationSlide';
import Modal from '../components/modal';
import {catchUpPromise} from "../../components/state-calculator";

export default {
	name: 'StationDetail',
	components: { StationSlide },
	props: {
		classUuid: '',
	},
	data() {
		return {
			loading: true,
		};
	},
	computed: {
		station() {
			return this.$actions.getStation(this.$store.stationUuid);
		},
		slides() {
			return this.$actions.getStationSlides(this.station?.uuid);
		},
		title() {
			const title = this.station?.settings?.title;
			return title ? title : this.station?.name;
		},
		currentSlide(){
			return this.$actions.getSlide(this.$store.stationSlide[this.station?.uuid]);
		},
		state(){
			return this.$actions.getClassState(this.station?.uuid);
		}
	},
	beforeCreate() {
		// Station uuid uit url halen
		this.$actions.setStationUuid(this.$route.params.uuid);
	},
	mounted() {
		// Bij het openen van een station, ga naar de eerste slide
		this.start();
	},
	methods: {
		start() {

			catchUpPromise.then(() => {

				if(!this.state?.start && this.station){
					window.axios.post(`/api/v1/station/${this.station.uuid}/start/${this.classUuid}`);
				}

				const stationSlide = this.$store.stationSlide[this.station.uuid];

				console.log({stationSlide});

				if(!stationSlide){
					this.setSlide(this.slides[0]);
				}

				this.loading = false;

			});

		},
		nextSlide(slide) {
			const nextSlide = this.$actions.slideAfter(this.station.uuid, slide.uuid);

			if (!nextSlide) {
				window.axios.post(`/api/v1/station/${this.station.uuid}/stop/${this.classUuid}`);
				this.back();
			}

			this.setSlide(nextSlide);
		},
		setSlide(slide) {
			window.axios.post(`/api/v1/station/${this.station.uuid}/slide/${this.classUuid}`, {
				slide: slide?.uuid,
			});
		},
		back() {
			this.setSlide(null);
			this.$router.push({ name: 'stations' });
		},
	},
	beforeDestroy() {
		this.$emit('stationsOverview');
	},
};
</script>

<style scoped></style>
